import { get } from 'svelte/store';
import { debug, formMap } from "./stores.js";

export const getQueryString = (a) => {
	if (a === undefined) {
		var a = window.location.search;
	}
	const substridx = a.indexOf("?")
	a = a.substr(substridx + 1).split("&");
	if (a == "") return {};
	let b = {};
	for (let i = 0; i < a.length; ++i) {
		let p = a[i].split("=", 2);
		if (p.length == 1) b[p[0]] = "";
		else b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
	}
	return b;
};

// sort objects in array by key
export const sortByKey = (array, key) => {
	return array.sort(function (a, b) {
		var x = a[key];
		var y = b[key];
		return x < y ? -1 : x > y ? 1 : 0;
	});
};

export const getURL = () => {
	return (location.protocol + '//' + location.host + location.pathname).replace(/\/$/, '');
}

// prefix keys with URLParams- before posting to server with writeForm
export const formatQueryString = () => {
	const obj = getQueryString();
	let obj2 = {};
	for (const property in obj) {
		obj2["URLParams-" + property] = obj[property];
	}
	return obj2;
}

// generate random string of specified length for user_id
export const randomID = (length) => {
	let result = "";
	let characters = "abcdefghijklmnopqrstuvwxyz0123456789";
	let charactersLength = characters.length;
	for (let i = 0; i < length; i++) {
		result += characters.charAt(
			Math.floor(Math.random() * charactersLength)
		);
	}
	return result;
};

// https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
export const shuffle = (array) => {
	let currentIndex = array.length, randomIndex;

	// While there remain elements to shuffle...
	while (currentIndex != 0) {

		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex--;

		// And swap it with the current element.
		[array[currentIndex], array[randomIndex]] = [
			array[randomIndex], array[currentIndex]];
	}
	return array;
}

export const encode = (obj) => {
	for (const i in obj) {
		obj[i] = encodeURIComponent(obj[i]);
	}
	console.log("encoded payload: ", obj)
	return obj;
}

// post questionnaire/form data route
export async function writeForm(apiURL, data) {
	console.log("Submitting form data...");
	try {
		data = encode(data);
		const resp = await fetch(apiURL, {
			method: "POST",
			mode: "cors",
			cache: "default",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({
				user_id: localStorage.getItem("user_id"),
				condition: localStorage.getItem("condition"),
				experiment_id: localStorage.getItem("experiment_id"),
				form_fields: data,
			}),
		});
		const response = await resp.json();
		if (response.success === "true") {
			console.log("Submitted form data successfully");
		} else {
			console.log("Fail to write/post form data");
		}
		return response;
	} catch (error) {
		console.log("Error writing form data", error);
	}
}

// process form data when user clicks button
export const handleSubmit = (apiURL, responses, redirectRoute) => {
	const response = writeForm(apiURL, responses);
	response.then(r => {
		console.log("Response", r);
		console.log("Called writeForm. Redirect to ", redirectRoute);
		// redirect to next route if available
		if (redirectRoute && redirectRoute != "" && !get(debug)) {
			window.location.replace(redirectRoute);
		}
	})

};


// process form data
export const parseFormdata = (form) => {
	console.log("$form:", form);
	let responses = form.values;
	// parse checkbox data
	const checked = Object.keys(form.values).filter(i => form.values[i] === "checked");
	for (const i in checked) {
		let response = "";
		const checkboxes = form[checked[i]].elements;
		for (const j in checkboxes) {
			if (checkboxes[j].checked) {
				response += checkboxes[j].defaultValue + ";";
			}
		}
		response = response.replace(/;(\s+)?$/, ""); // remove final comma
		responses[checked[i]] = response;
	}
	return responses;
}


export const arrayObjects2CSV = (objArray) => {
	// https://github.com/hauselin/lab_exp/blob/master/routes/helpers/helpers.js
	let array =
		typeof objArray != "object" ? JSON.parse(objArray) : objArray;
	let line = "";
	let result = "";
	let columns = [];
	let i = 0;
	for (let j = 0; j < array.length; j++) {
		for (var key in array[j]) {
			var keyString = key + "";
			keyString = '"' + keyString.replace(/"/g, '""') + '",';
			if (!columns.includes(key)) {
				columns[i] = key;
				line += keyString;
				i++;
			}
		}
	}
	line = line.slice(0, -1);
	result += line + "\r\n";
	for (let i = 0; i < array.length; i++) {
		let line = "";
		for (let j = 0; j < columns.length; j++) {
			let value =
				typeof array[i][columns[j]] === "undefined"
					? ""
					: array[i][columns[j]];
			let valueString = value + "";
			valueString = encodeURIComponent(valueString);  // escape special characters
			line += '"' + valueString.replace(/"/g, '""') + '",';
		}

		line = line.slice(0, -1);
		result += line + "\r\n";
	}
	return result;
};

// TODO
export const saveParams2Storage = (params) => {

}


//const testURL = 'https://notch.insights.supply/cb?token=f521fff7-d879-4fdc-958c-2b96b0a90323&RID=${e://Field/rid}';
export const parseLucid = (redirectURL) => {
	console.log('parseLucid');
	console.log('redirectURL', redirectURL);
	let queryParams = JSON.parse(localStorage.getItem("queryParams"));
	let rid = queryParams.rid;
	if (rid === undefined) {
		rid = queryParams.RID;
	}
	return redirectURL.replace("${e://Field/rid}", rid);
}

export const parseMturk = () => {
	console.log("parseMturk");
	let expParams = getExpParams();
	let code = expParams['completion-code'].trim();
	return code;
}

export const getExpParams = () => {
	let params = {};
	params.user_id = localStorage.getItem("user_id");
	params.condition = Number(localStorage.getItem("condition"));
	params.experiment_id = localStorage.getItem("experiment_id");
	// if (params.n_entities !== null && params.n_entities !== undefined) {
	// 	params.n_entities = JSON.parse(localStorage.getItem("entities")).length;
	// }
	params.n_entities = JSON.parse(localStorage.getItem("entities")).length;
	params.queryParams = JSON.parse(localStorage.getItem("queryParams"));

	const experiment_parameters = JSON.parse(localStorage.getItem("experiment_parameters"));
	if (experiment_parameters) {
		experiment_parameters.forEach(i => {
			params[i.parameter] = i.value;
		})
	} else {
		// console.log(params);
		return params;
	}

	// define experiment parameters
	// when to show intervention
	let perc = Number(params["intervention-perc"]) / 100;
	let intervention_type = params["intervention-type"];

	if (intervention_type === "") {
		params['intervention-perc'] = "";
		params.intervention_idx = Infinity;  // never show it
	} else if (perc === "" && intervention_type !== "") {  // if intervention type is set, but intervention perc is not, default to 0.5 (show intervention halfway)
		params.intervention_idx = Math.floor(params.n_entities * 0.5) - 1;
	} else {
		// remember to minus 1 (because dwell time is computed AFTER card is no longer in view); e.g., 14 if to show at idx 15
		params.intervention_idx = Math.floor(params.n_entities * perc) - 1;
	}
	// console.log(params);
	return params;
}

export const addQueryParam = (url, key, value) => {
	let urlUpdated = url;
	if (urlUpdated.includes("?")) {
		urlUpdated += "&" + key + "=" + value;
	} else {
		urlUpdated += "?" + key + "=" + value;
	}
	return urlUpdated;
}

export const getRedirectRoutes = () => {
	let root = location.protocol + '//' + location.host;
	const experiment_parameters = JSON.parse(localStorage.getItem("experiment_parameters"));
	const expID = localStorage.getItem("experiment_id");
	let forms;
	if (experiment_parameters) {
		const expParams = getExpParams();
		forms = JSON.parse(expParams.forms);
	} else {
		forms = [];
	}
	console.log("redirection forms:", forms);

	let routes = [];
	forms.forEach(i => {
		let obj = {};
		for (let k of Object.keys(get(formMap))) {
			if (k === i) {
				obj[root + get(formMap)[k]] = 0;  // assign 0 to all routes (not visited yet; will switch to 1 if visited)
			}
		}
		routes.push(obj);
	})

	// // always redirect to final page
	// if (forms.length > 0) {
	// 	let obj = {};
	// 	obj[root + "/form/final"] = 0;
	// 	routes.push(obj);
	// }

	// if it's an experiment and there's a custom route, always append as last route
	if (expID !== "solarflare" && getExpParams()["platform"] == "custom") {
		const params = getExpParams();
		let redirectURL = decodeURIComponent(params["redirect-url"]);
		// add user_id to redirectURL as query parameter
		redirectURL = addQueryParam(redirectURL, "user_id", params["user_id"]);
		// add all auery params
		let queryParams = params["queryParams"];
		for (let k of Object.keys(queryParams)) {
			redirectURL = addQueryParam(redirectURL, k, queryParams[k]);
		}
		let obj = {}
		obj[redirectURL] = 0;
		routes.push(obj)
	} else if (expID !== "solarflare" && routes.length === 0) {
		// if it's an experiment but no forms specified, redirect to home page
		let obj = {};
		obj[root] = 0;
		routes.push(obj);
	}

	if (expID === "solarflare") {
		routes = [];
		let routesOptions = [];
		console.log("experiment_id: solarflare", "redirection routes:", routesOptions);
		routesOptions = routesOptions.map(i => root + i);
		routesOptions.forEach(i => {
			const obj = {};
			obj[i] = 0;
			routes.push(obj)
		})
	}

	let nextRoute = routes.filter(i => Object.values(i) == 0)[0];
	if (nextRoute === undefined) {
		nextRoute = root;
	} else {
		nextRoute = Object.keys(nextRoute)[0];
	}
	localStorage.setItem("nextRoute", nextRoute);
	localStorage.setItem('redirectionRoutes', JSON.stringify(routes));
	console.log("redirection routes:", routes);
	console.log("redirection nextRoute:", nextRoute);
	return routes;
}


export const updateNextRoute = () => {
	let root = location.protocol + '//' + location.host;
	let routes = JSON.parse(localStorage.getItem("redirectionRoutes"));
	if (routes === undefined || routes === null) {
		console.log("not redirecting to any routes on page submit")
		return;
	}
	if (routes.length == 1 || routes === undefined) {
		let obj = {};
		obj[location.protocol + '//' + location.host] = 0;
		routes.push(obj);
	}
	const currentURL = getURL();
	let routesArray = [].concat.apply([], routes.map(i => Object.keys(i)));
	if (routesArray.includes(currentURL)) {
		const mask = routesArray.map(i => i == currentURL);
		const idx = mask.indexOf(true);
		routes[idx][currentURL] = 1;
	}
	let nextRoute = routes.filter(i => Object.values(i) == 0)[0];
	if (nextRoute === undefined) {
		nextRoute = root;
	} else {
		nextRoute = Object.keys(nextRoute)[0];
	}
	console.log("redirect nextRoute", nextRoute);
	localStorage.setItem('nextRoute', nextRoute);
	localStorage.setItem('redirectionRoutes', JSON.stringify(routes));
}


// check if url/path is video
export const isVideo = (url) => {
	let ext = url.split('.').pop();
	return ext === "mp4" || ext === "webm" || ext === "ogg";
}
